module.exports = __webpack_public_path__ + "media/images/pc/plans/inclusion_12-d71d02c6d06d49634bb9830c596d5d6f.png";